import { TENDER_TYPE } from '@/constants/tender';

export const getTenderType = (route, inland = 'Казахстан') => {
  const tenderInternal = route?.every(l => l?.country === inland);
  return tenderInternal ? TENDER_TYPE.INLAND : TENDER_TYPE.FOREIGN;
};

export const parseTenderId = tender => tender?.conditions?.id;